import {NEW_SHARED_CDN_PATH, OLD_SHARED_CDN_PATH, SERVE_WEBP_IMAGES, USE_NEW_CDN} from "Setup/config";
import React, {useState} from "react";

const WebpImage = ({src = "", ignoreWebp = false, ...rest}) => {
    if (!src || src.length === 0) return null;

    const [imageError, setImageError] = useState(false);

    if (!SERVE_WEBP_IMAGES || ignoreWebp) return (
        <img {...rest} src={src}/>
    );

    const regularFallback = src;
    const icon = src.split("/").pop();
    const extensionLength = icon.includes(".webp") ? 5 : 4;

    let webpUrl;
    if (src.includes(OLD_SHARED_CDN_PATH) || src.includes(NEW_SHARED_CDN_PATH)) {
        webpUrl = `${src.substring(0, src.length - icon.length)}${USE_NEW_CDN ? "webp/" : ""}${icon.substring(0, icon.length - extensionLength)}.webp`;
    } else {
        webpUrl = `${regularFallback.substring(0, regularFallback.length - 4)}.webp`;
    }

    const regularWebP = !icon.includes('webp') ? webpUrl : regularFallback;

    return (
        <picture>
            {!imageError && <source srcSet={regularWebP} type="image/webp"/>}
            <img {...rest} src={regularFallback} onError={() => setImageError(true)}/>
        </picture>
    );
}

export default WebpImage;
